import { computed } from 'vue';
import { useAssortmentCanvasStore } from '@/stores/assortment-canvas';
import { usePermission } from './use-permission';

/**
 * Composable for canvas editing permission checks.
 * Combines user permission to edit assortment canvas with canvas lock status.
 */
export function useCanvasEditability() {
  const { canEditAssortmentCanvas } = usePermission();
  const store = useAssortmentCanvasStore();

  const canvasCanBeEdited = computed(
    () => canEditAssortmentCanvas.value && !store.isCanvasLockedByFinalCheckpoint
  );

  return { canvasCanBeEdited };
}
